"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../../styles/styles"));
const useWebDesktopDesign_1 = __importDefault(require("../../../hooks/useWebDesktopDesign"));
const button_1 = __importDefault(require("../../button/button"));
const typesConstants_1 = require("../../../constants/typesConstants");
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const actionsSlice_1 = require("../../../features/actions/actionsSlice");
const eventConstants_1 = require("../../../constants/eventConstants");
const useAppSelector_1 = __importDefault(require("../../../hooks/useAppSelector"));
const loanDetailsConstants_1 = require("../loanDetailsConstants");
const FieldErrorMessageComponent_1 = __importDefault(require("../../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const pressable_1 = __importDefault(require("../../pressable/pressable"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const themes_1 = __importDefault(require("../../../styles/themes"));
const ActionButtons = ({ actions }) => {
    const { schedule } = useAppSelector_1.default((state) => ({
        schedule: state.schedule.schedule,
    }));
    const dispatch = useAppDispatch_1.default();
    const isDesktop = useWebDesktopDesign_1.default();
    const [errorMessage, setErrorMessage] = react_1.useState('');
    const [selectedReasons, setSelectedReasons] = react_1.useState([]);
    const [selectedAction, setSelectedAction] = react_1.useState(undefined);
    const [actionPayload, setActionPayload] = react_1.useState(undefined);
    const containerStyles = react_1.useMemo(() => (isDesktop ? [styles_1.default.flexDirectionRow] : []), [isDesktop]);
    const buttonStyle = react_1.useMemo(() => (isDesktop ? [] : [styles_1.default.marginTen]), [isDesktop]);
    const checkBoxDesktopStyles = [
        styles_1.default.marginTen,
        styles_1.default.flexDirectionRow,
        styles_1.default.flexWrap,
        styles_1.default.alignSpaceBetween,
    ];
    const checkBoxContainerStyle = react_1.useMemo(() => (isDesktop ? checkBoxDesktopStyles : []), [isDesktop]);
    const checkBoxItemStyle = react_1.useMemo(() => (isDesktop ? { width: '30%', marginVertical: 3 } : []), [isDesktop]);
    const customActionHandler = react_1.useCallback(async (actionKey, metadata, action_trigger_url) => {
        const payload = {
            scheduleId: schedule.id,
            action_key: actionKey,
            metadata,
            action_trigger_url,
        };
        if (schedule.category === typesConstants_1.SCHEDULE_CATEGORY_MANUAL_CONFIRMATION &&
            [loanDetailsConstants_1.REJECT_LOAN_ACTION_KEY, loanDetailsConstants_1.ACCEPT_LOAN_ACTION_KEY].includes(actionKey)) {
            setActionPayload(payload);
            setSelectedAction(actionKey);
            return;
        }
        dispatch(actionsSlice_1.customAction(payload));
    }, [schedule, dispatch]);
    const toggleReason = (value) => {
        setSelectedReasons((prev) => prev.includes(value) ? prev.filter((reason) => reason !== value) : [...prev, value]);
    };
    const onSave = react_1.useCallback(() => {
        if (!actionPayload)
            return;
        // Let's check if it's a loan accept action so we can trigger the action and stop
        if (actionPayload.action_key === loanDetailsConstants_1.ACCEPT_LOAN_ACTION_KEY) {
            dispatch(actionsSlice_1.customAction(actionPayload));
            return;
        }
        if (!selectedReasons) {
            setErrorMessage('Select a reason!');
            return;
        }
        dispatch(actionsSlice_1.customAction({
            ...actionPayload,
            metadata: {
                ...actionPayload.metadata,
                rejection_reasons: selectedReasons,
            },
        }));
    }, [actionPayload, selectedReasons]);
    const onClose = react_1.useCallback(() => {
        setSelectedAction(undefined);
        setSelectedReasons([]);
    }, []);
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen] },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(react_native_1.View, { style: [containerStyles, styles_1.default.alignCenterCenter] }, actions.map((el) => (react_1.default.createElement(react_native_1.View, { key: el.action_key, style: buttonStyle },
                react_1.default.createElement(button_1.default, { text: el.action_label, onPress: () => customActionHandler(el.action_key, el.metadata, el.action_trigger_url), fill: selectedAction === el.action_key, eventName: eventConstants_1.LOAN_ACTION_PRESS }))))),
            selectedAction && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.marginTen] },
                selectedAction === loanDetailsConstants_1.REJECT_LOAN_ACTION_KEY ? (react_1.default.createElement(react_native_1.View, { style: checkBoxContainerStyle },
                    !!errorMessage && react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: errorMessage }),
                    loanDetailsConstants_1.MANUAL_CONFIRMATION_REJECTION_REASONS.map(({ value, label }) => (react_1.default.createElement(react_native_1.View, { key: value, style: checkBoxItemStyle },
                        react_1.default.createElement(react_native_paper_1.Checkbox.Item, { label: label, status: selectedReasons.includes(value) ? 'checked' : 'unchecked', onPress: () => toggleReason(value), theme: themes_1.default.textInput, color: colors_1.default.BLUE })))))) : (react_1.default.createElement(react_native_1.Text, { style: styles_1.default.textCenter }, `Are you sure you want to accept this loan? `)),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTen, styles_1.default.centerChilds] },
                    react_1.default.createElement(pressable_1.default, { eventName: eventConstants_1.LOAN_ACTION_CONFIRMATION_SAVE_PRESS, onPress: onSave, style: [styles_1.default.button, styles_1.default.minWidth, styles_1.default.greenBackground] },
                        react_1.default.createElement(react_native_1.Text, { style: [
                                styles_1.default.textColorBlack,
                                styles_1.default.marginTen,
                                styles_1.default.fontSizeText,
                            ] }, `Save `)),
                    react_1.default.createElement(pressable_1.default, { eventName: eventConstants_1.LOAN_ACTION_CONFIRMATION_CLOSE_PRESS, onPress: onClose, style: [styles_1.default.button, styles_1.default.minWidth, styles_1.default.redBackground] },
                        react_1.default.createElement(react_native_1.Text, { style: [
                                styles_1.default.textColorWhite,
                                styles_1.default.marginTen,
                                styles_1.default.fontSizeText,
                            ] }, `Close `))))))));
};
exports.default = ActionButtons;
